import { Link } from "@tanstack/react-router";
import { Button, type ButtonProps } from "@/components/ui/button";
import { useAuth } from "@/hooks/use-auth";
import { useGoogleSignIn } from "@/hooks/use-google-sign-in";
import { buildNextParam } from "@/lib/auth-redirect";

export function GenerateCta({
  type,
  children,
  unstyled,
  className,
  ...buttonProps
}: Omit<ButtonProps, "type"> & { type?: string; children: React.ReactNode; unstyled?: boolean }) {
  const { user } = useAuth();
  const next = buildNextParam("/generate", type ? { type } : undefined);
  const { signIn, ready } = useGoogleSignIn(next);

  if (!user) {
    if (unstyled) {
      return (
        <button type="button" className={className} disabled={!ready} onClick={signIn}>
          {children}
        </button>
      );
    }
    return (
      <Button {...buttonProps} className={className} disabled={!ready} onClick={signIn}>
        {children}
      </Button>
    );
  }

  if (unstyled) {
    return (
      <Link to="/generate" search={type ? { type } : undefined} className={className}>
        {children}
      </Link>
    );
  }

  return (
    <Button {...buttonProps} className={className} asChild>
      <Link to="/generate" search={type ? { type } : undefined}>
        {children}
      </Link>
    </Button>
  );
}
